import { Dismiss20Regular } from "@fluentui/react-icons";

interface CardHeaderProps {
    title: string;
    subtitle: string;
    onClick?: () => void;
    icon: JSX.Element;

}

export function CardHeader(cardHeaderProps: CardHeaderProps) {
    return (
        <div className="ps-4 -ml-1 mt-2 pt-2 px-2 ">
            <div className="flex">
                <span className="pt-1">
                    {cardHeaderProps.icon}
                </span>
                <span className="grid grid-cols-1 ps-2">
                    <div className="text-text-light dark:text-text-dark font-bold text-base">
                        {cardHeaderProps.title}
                    </div>
                    <div className="text-text-light dark:text-text-dark font-normal text-sm">
                        {cardHeaderProps.subtitle}
                    </div>
                </span>
                {cardHeaderProps.onClick && (
                    <div className="mr-1 grow text-right z-10">
                        <Dismiss20Regular onClick={cardHeaderProps.onClick} />
                    </div>
                )}
            </div>
        </div>
    );
}

